import { combineReducers } from '@reduxjs/toolkit';

import notificationsSlice from 'entities/Notification/model/notificationsSlice';
import offerReducer from 'entities/Offer/model/offerSlice';
import { baseApi } from 'shared/api/baseApi';
import commonSlice from 'shared/model/commonSlice';
import sidebarReducer from 'widgets/Sidebar/model/sidebarSlice';

export const rootReducer = combineReducers({
	sidebarReducer,
	commonSlice,
	notificationsSlice,
	offerReducer,
	[baseApi.reducerPath]: baseApi.reducer,
});
